import React from 'react'
import { ChartersPageFirstSection } from '../ChartersComponents/ChartersPageFirstSection';
import { ChartersPageFSecondSection } from '../ChartersComponents/ChartersPageFSecondSection'

export const ChartersPage = () =>  {
  return (
    <section id="Charter">
      <ChartersPageFirstSection/>
      <ChartersPageFSecondSection/>
    </section>
  )
}
